import request from "./api_client";

function getData(url) {
    return request({
        url: url,
        method: 'GET',
    });
}
function create(formData, url) {
    return request({
        url: url,
        method: 'POST',
        data: formData,
    });
}
function update(formData, url) {
    return request({
        url: url,
        method: 'PUT',
        data: formData,
    });
}
function remove(url, formData) {
    return request({
        url: url,
        method: 'DELETE',
        data: formData
    })
}
const DataClient = {
    getData, update, create, remove
};

export default DataClient;